import React, { useState, useEffect } from "react"
import InputField from "../../components/InputField/InputField"
import { ShoppingCart } from "../../components/shoppingcart"
import { BackButton } from "../../components/BackButon"
import {
  createOrder,
  createPartialOrder,
  generateLink
} from "../../utils/ApiRequests"
import MiniLoader from "../../components/Loaders/MiniLoader"
import { useToasts } from "react-toast-notifications"
import Navbar from "../../components/Navbar/Navbar"
import { useEvent } from "../../context/EventContext"
import { useHistory } from "react-router-dom"
import { useCart } from "react-use-cart"

const PartialCheckout = () => {
  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
    amount: ""
  })
  const { currentRegistry } = useEvent()
  const [localRegistry, setLocalRegistry] = useState(currentRegistry)
  const { items } = useCart()
  const [loading, setLoading] = useState(false)
  const { addToast } = useToasts()
  const history = useHistory()

  const priceLimit = items[0]?.price
  const contributionId = `${items[0]?.id}`

  // Persist form to local storage
  useEffect(() => {
    const persistedCheckout = JSON.parse(localStorage.getItem("checkout"))
    if (persistedCheckout) {
      setForm(persistedCheckout)
    }
  }, [])

  useEffect(() => {}, [form])

  // persist registry to local storage
  useEffect(() => {
    const persistedRegistry = localStorage.getItem("regLoc")
    if (persistedRegistry) {
      setLocalRegistry(persistedRegistry)
    }
  }, [])

  useEffect(() => {
    localStorage.setItem("regLoc", localRegistry)
  }, [localRegistry])

  const handleForm = e => {
    const name = e.target.name
    const value = e.target.value
    const newEntry = { [name]: value }
    setForm({ ...form, ...newEntry })
  }

  const currentUrl = window.location.origin

  console.log(currentUrl)

  const callback_url = `${currentUrl}/checkout/confirm-transaction`

  const createOrderForRegistry = async () => {
    setLoading(true)

    const buyerInfo = {
      email: form.email,
      phone: form.phone,
      first_name: form.firstname,
      last_name: form.lastname
    }
    const formData = {
      buyer: buyerInfo,
      amount: form.amount,
      contribution: contributionId
    }

    try {
      const data = await createPartialOrder(formData)
      const orderId = data?.data.data._id
      try {
        const res = await generateLink(orderId, callback_url)
        window.open(res?.data.data.link, "_self")
        setLoading(false)
      } catch (error) {
        addToast(error.response?.data.message || "An Error Occured", {
          appearance: "error"
        })
        setLoading(false)
      }
    } catch (error) {
      addToast(error.response?.data.message || "An Error Occured", {
        appearance: "error"
      })
      setLoading(false)
    }
  }

  const checkInputs = () => {
    if (
      form.firstname === "" ||
      form.lastname === "" ||
      form.email === "" ||
      form.phone === "" ||
      form.amount === "" ||
      form.amount > priceLimit
    ) {
      return false
    } else {
      return true
    }
  }

  return (
    <>
      <Navbar />

      <div className="global-container py-5">
        <h2 className="font-semibold my-5 px-2">Checkout</h2>
        <div className="flex flex-wrap -mx-2 mb-8">
          <div className="mobiles:w-full w-2/3 lg:w-2/3 px-2 mb-4">
            <div className="hidden mobiles:block mb-3">
              <ShoppingCart items={items} no_of_items={items.length} />
            </div>
            <nav className="flex sm:flex-row border-b border-gray">
              <button
                className={` py-4 px-6 block hover:text-black focus:outline-none text-black border-b border-black text-xs border-black-400`}
              >
                CUSTOMER INFO
              </button>
            </nav>

            <div className="mt-10 cart__customer-info-form">
              <h2 className="my-3">Gifter’s Information</h2>

              <div className="flex ">
                <div className="mobiles:w-full w-1/2 pr-2">
                  <InputField
                    label="First Name"
                    id="firstname"
                    htmlFor="firstname"
                    placeholder="Enter first name"
                    name="firstname"
                    value={form.firstname}
                    required
                    handleChange={handleForm}
                  />
                </div>
                <div className="mobiles:w-full w-1/2 pr-2">
                  <InputField
                    label="Last Name"
                    id="lastname"
                    htmlFor="lastname"
                    placeholder="Enter last name"
                    value={form.lastname}
                    required
                    name="lastname"
                    handleChange={handleForm}
                  />
                </div>
              </div>

              <InputField
                label="Email Address"
                id="email"
                type="email"
                htmlFor="email"
                placeholder="Enter your email here"
                value={form.email}
                name="email"
                required
                handleChange={handleForm}
              />

              <div className="flex">
                <div class="mobiles:w-full w-1/2 pr-2 mb-4">
                  <InputField
                    label="Amount"
                    id="amount"
                    htmlFor="amount"
                    placeholder="Enter amount"
                    type="number"
                    value={form.amount}
                    required
                    pattern="^0[0-9]{10}"
                    name="amount"
                    handleChange={handleForm}
                  />
                </div>
                <div class="mobiles:w-full w-1/2 pr-2 mb-4">
                  <InputField
                    label="Phone"
                    id="PhoneNumber"
                    htmlFor="PhoneNumber"
                    placeholder="Enter Phone Number"
                    value={form.phone}
                    required
                    pattern="^0[0-9]{10}"
                    name="phone"
                    handleChange={handleForm}
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-between mt-10">
              <BackButton
                onClick={() => history.goBack()}
                text="Back to Shop"
              />
              {loading ? (
                <MiniLoader />
              ) : (
                <button
                  type="submit"
                  className={`px-5 py-3 text-center rounded text-white bg-sbg-light-green font-medium text-xs focus:outline-none ${
                    !checkInputs() && "btn-disabled"
                  }`}
                  onClick={() => {
                    createOrderForRegistry()
                  }}
                  disabled={!checkInputs()}
                >
                  CHECKOUT
                </button>
              )}
            </div>
          </div>

          <div class="mobiles:w-full w-1/3 lg:w-1/3 px-2 mobiles:hidden">
            <ShoppingCart
              items={items}
              no_of_items={items.length}
              amount={form.amount}
            />
          </div>
        </div>
      </div>
    </>
  )
}
export default PartialCheckout
